<template>
    <div>
        <div class="d-flex align-items-center filter-wrapper flex-wrap">
            <div class="form-group">
                <label>Дата начала периода</label>
                <date-component v-model="currFilters.dateFrom"/>
            </div>
            <div class="form-group">
                <label>Дата окончания периода</label>
                <date-component v-model="currFilters.dateTo"/>
            </div>
            <div class="form-group select2">
                <label>Вид деятельности</label>
                <Select2 :options="kindActivities" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.kindActivityIds"/>
            </div>
            <div class="form-group select2">
                <label>Тип организации</label>
                <Select2 :options="organizationTypes" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.organizationTypeIds"/>
            </div>
            <div class="form-group select2">
                <label>Форма собственности</label>
                <Select2 :options="opf" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.opfIds"/>
            </div>
            <div class="form-group select2">
                <label>Район</label>
                <Select2 :options="districts" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.districtIds"/>
            </div>
            <div class="form-group select2">
                <label>Наименование организации</label>
                <Select2 :options="organizations" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.organizationIds"/>
            </div>
        </div>

      <div class="form-group px-0 col-8 select2">
       <div class="d-flex align-items-center">
         <label class="mr-2">Вычислить и отобразить в отчете</label>
         <Checkbox v-model="fieldsChecked"
                   :checked="fieldsChecked"
                   id="fields"
                   text="Все поля"
         />
       </div>
        <Select2 :options="fields" :settings="{multiple:true,language:'ru'}" placeholder="(Выберите поля)"
                 v-model="currFilters.fields"/>
      </div>
      <div class="form-group px-0 col-12">
        <div class="check-box-group pt-4">
          <Checkbox v-model="currFilters.includeRefusals"
                    :checked="currFilters.includeRefusals"
                    id="includeRefusals"
                    text="с учетом отказов"
          />
        </div>
      </div>
      <div class="form-group px-0 mb-0 col-2">
        <div class="card-footer px-0 d-flex">
          <button-component @click="apply" class="btn-xs">Сформировать</button-component>
          <button-component kind="secondary" class="btn-xs" @click="reset">Сбросить</button-component>
          <button class="btn-success btn-d btn-xs" @click="exportReport">
            <i class="fa fa-download"></i>Экспорт</button>
        </div>
      </div>
    </div>
</template>

<script>
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import DateComponent from "../../../common/components/DateComponent";
  import NsiApi from "../../admin/api/nsi";
  import OrgApi from "../../organization/api/organizations";
  import Checkbox from "../../../common/ui/checkbox";
  import Api from "../api/serviceproviders";
  export default {
    name: "ReportOrgCapacityFilter",
    components: {Checkbox, ButtonComponent, DateComponent},
    props: {
      filters: Object
    },
    data() {
      return {
        fieldsChecked: true,
        kindActivities: [],
        organizationTypes: [],
        opf: [],
        districts: [],
        organizations: [],
        fields: [],
        currFilters: this.filters,
        correctionFields: ['KindActivity', 'OpfName', 'CapacityPlan', 'FillingFact', 'PatientCount', 'PatientCompensation']
      }
    },
    created() {
      this.loadDictionaries();
    },
    watch: {
      fieldsChecked: {
        handler(val) {
          console.log(val)
          if(val === true) {
            this.currFilters.fields = this.fields.map(item => item.id)
          }
          if(val === false) {
            this.currFilters.fields = []
          }
        },
        deep: true
      },

    },
    methods: {
      loadDictionaries() {
        NsiApi.getNsi('kindactivity')
          .then((response) => {
            this.kindActivities = response.data;
          });
        NsiApi.getNsi('organizationtype')
          .then((response) => {
            this.organizationTypes = response.data;
          });
        NsiApi.getNsi('opf', {parentId: -1})
          .then((response) => {
            this.opf = response.data;
          });
        NsiApi.getNsi('district')
          .then((response) => {
            this.districts = response.data;
          });
        OrgApi.search({pageNumber: 0, pageSize: -1})
          .then((response) => {
            this.organizations = response.data.items.map(x => ({id: x.id, text: x.name}));
          });
        Api.getOrgCapacityReportFields()
          .then((response) => {
            this.fields = response.data.map((x) => ({id: x.name, text: x.title}));
            this.currFilters.fields = this.fields.map(item => item.id)
          });
      },
      apply() {

        const filters = Object.assign({}, this.currFilters);
        this.$emit('apply', filters);
      },
      reset() {
        this.currFilters = {
          dateFrom: null,
          dateTo: null,
          kindActivityIds: [],
          organizationTypeIds: [],
          opfIds: [],
          districtIds: [],
          organizationIds: [],
          includeRefusals: true,
          fields: []
        };
        const filters = Object.assign({}, this.currFilters);
        this.$emit('reset', filters);
      },
      exportReport() {
        const filters = Object.assign({}, this.currFilters);
        this.$emit('exportReport', filters);
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "src/assets/theme/default/colors";

    .form-group {
        label {
            font-weight: 400 !important;
            color: $gray-dark;
            font-size: 16px;
        }
    }
    .filter-wrapper{
        div:not(:last-child){
            margin-right: 16px;
        }
    }
    .card-footer {
        padding-top: 36px;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }
    .btn-d{
      min-width: 120px;
        border: none;
        padding: 14px 24px;
        border-radius: 24px;
        i{
            padding-right: 12px;
        }
    }
    .check-box-group * {
        display: inline-block;
    }
</style>
